import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { TablesGraphQLResourceQuery } from '~src/catalog/fetchers/TablesGraphQLResourceQuery';
import { TablesWithCrass } from '~src/catalog/resources/TablesWithCrass';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { TableContentType, TableWithCRASSSearchSubspaceType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const TableDefinition: ExplorableItemDefinition = {
  itemType: 'table',
  pluralName: Messages.tables,
  singularName: Messages.table,
  emptyStateMessage: Messages.tablesEmptyMessage,
  contentFilterKeys: TableContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => new TablesGraphQLResourceQuery(),
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};

export const TableWithCrassDefinition: ExplorableItemDefinition = {
  itemType: 'tableWithCrass',
  pluralName: Messages.tables,
  singularName: Messages.table,
  emptyStateMessage: Messages.tablesEmptyMessage,
  contentFilterKeys: TableWithCRASSSearchSubspaceType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return TablesWithCrass.all().withExtraParams(TableContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
